import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { drag, DragBehavior } from 'd3-drag';
import { select } from 'd3-selection';
import { EcgMeasures } from '../../../models/ecgmeasures';
import { IWindowViewModel } from '../../../models/interfaces';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: '[caliper-window]',
    templateUrl: './window.component.html',
    styleUrls: ['./window.component.css'],
    imports: [DecimalPipe],
    standalone: true,
})
export class WindowComponent implements OnInit {
    // events

    @Output()
    removeClicked = new EventEmitter<any>();

    @Output()
    positionChange = new EventEmitter<{ x: number; y: number }>();

    // data members

    @Input()
    window!: IWindowViewModel;
    @Input()
    measures!: EcgMeasures;

    // constructor

    constructor(private elementRef: ElementRef) {}

    // public functions

    ngOnInit() {
        const onDrag: DragBehavior<any, any, any> = drag()
            .on('start', (event) => {
                event.sourceEvent.stopPropagation();
            })
            .on('drag', (event) => {
                this.positionChange.emit({ x: event.x, y: event.y });
            });

        select(this.elementRef.nativeElement).select('#window').call(onDrag);
    }

    onRemoveClick() {
        this.removeClicked.emit();
    }
}
